import React from 'react';
import styles from './Skeleton.module.css';

interface SkeletonProps {
  variant?: 'text' | 'rectangular' | 'circular';
  width?: string | number;
  height?: string | number;
  count?: number;
}

const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'text',
  width = '100%',
  height,
  count = 1
}) => {
  const skeletonHeight = height || (variant === 'text' ? '1em' : variant === 'circular' ? '40px' : '200px');
  const skeletonWidth = typeof width === 'number' ? `${width}px` : width;

  const skeletonStyle = {
    width: skeletonWidth,
    height: typeof skeletonHeight === 'number' ? `${skeletonHeight}px` : skeletonHeight,
  };

  const skeletons = Array.from({ length: count }, (_, index) => (
    <div
      key={index}
      className={`${styles.skeleton} ${styles[variant]}`}
      style={skeletonStyle}
    />
  ));

  return <>{skeletons}</>;
};

// Preset skeleton for page content
export const PageSkeleton: React.FC = () => {
  return (
    <div className={styles.pageSkeleton}>
      {/* Header skeleton */}
      <div className={styles.headerSkeleton}>
        <Skeleton variant="rectangular" height={200} />
      </div>

      {/* Content skeleton */}
      <div className={styles.contentSkeleton}>
        <Skeleton variant="text" width="60%" height={32} />
        <div style={{ marginTop: '16px' }}>
          <Skeleton variant="text" count={3} />
        </div>
        <div style={{ marginTop: '24px' }}>
          <Skeleton variant="rectangular" height={300} />
        </div>
        <div style={{ marginTop: '24px' }}>
          <Skeleton variant="text" count={5} />
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
